[
  [
    { "lat": 55, "lng": 15 },
    { "lat": 55, "lng": 1 },
    { "lat": 40, "lng": 1 },
    { "lat": 40, "lng": 15 }
  ],
  [
    { "lng": 8.659819, "lat": 46.0233 },
    { "lng": 8.633266, "lat": 46.03273 },
    { "lng": 8.56973, "lat": 46.04218 },
    { "lng": 8.477268, "lat": 46.14229 },
    { "lng": 8.38593, "lat": 46.18059 },
    { "lng": 8.365009, "lat": 46.20668 },
    { "lng": 8.338326, "lat": 46.29113 },
    { "lng": 8.277115, "lat": 46.25639 },
    { "lng": 8.244319, "lat": 46.22479 },
    { "lng": 8.25504, "lat": 46.1737 },
    { "lng": 8.220272, "lat": 46.0853 },
    { "lng": 8.156519, "lat": 46.03575 },
    { "lng": 8.121533, "lat": 46.02264 },
    { "lng": 8.063555, "lat": 45.93807 },
    { "lng": 8.024118, "lat": 45.9131 },
    { "lng": 7.964514, "lat": 45.9063 },
    { "lng": 7.942328, "lat": 45.86456 },
    { "lng": 7.899453, "lat": 45.83417 },
    { "lng": 7.861293, "lat": 45.82673 },
    { "lng": 7.779909, "lat": 45.8295 },
    { "lng": 7.752747, "lat": 45.83978 },
    { "lng": 7.701133, "lat": 45.83561 },
    { "lng": 7.669594, "lat": 45.84911 },
    { "lng": 7.640307, "lat": 45.88286 },
    { "lng": 7.58941, "lat": 45.88105 },
    { "lng": 7.529595, "lat": 45.86574 },
    { "lng": 7.402153, "lat": 45.80852 },
    { "lng": 7.317926, "lat": 45.82216 },
    { "lng": 7.229621, "lat": 45.77666 },
    { "lng": 7.195038, "lat": 45.77046 },
    { "lng": 7.151519, "lat": 45.78199 },
    { "lng": 7.098531, "lat": 45.76923 },
    { "lng": 7.048087, "lat": 45.78678 },
    { "lng": 6.977199, "lat": 45.86267 },
    { "lng": 6.909759, "lat": 45.95444 },
    { "lng": 6.863818, "lat": 45.95577 },
    { "lng": 6.816051, "lat": 45.98056 },
    { "lng": 6.793205, "lat": 46.00764 },
    { "lng": 6.782526, "lat": 46.04831 },
    { "lng": 6.751912, "lat": 46.05915 },
    { "lng": 6.724837, "lat": 46.0837 },
    { "lng": 6.701711, "lat": 46.16207 },
    { "lng": 6.716947, "lat": 46.2283 },
    { "lng": 6.736484, "lat": 46.26473 },
    { "lng": 6.694572, "lat": 46.30485 },
    { "lng": 6.683491, "lat": 46.36284 },
    { "lng": 6.639234, "lat": 46.37188 },
    { "lng": 6.527685, "lat": 46.36772 },
    { "lng": 6.443115, "lat": 46.32769 },
    { "lng": 6.375001, "lat": 46.31766 },
    { "lng": 6.395667, "lat": 46.28306 },
    { "lng": 6.399512, "lat": 46.24953 },
    { "lng": 6.366316, "lat": 46.17066 },
    { "lng": 6.339664, "lat": 46.1472 },
    { "lng": 6.263675, "lat": 46.11975 },
    { "lng": 6.23886, "lat": 46.09161 },
    { "lng": 6.158579, "lat": 46.05435 },
    { "lng": 6.081472, "lat": 46.05739 },
    { "lng": 6.050651, "lat": 46.04563 },
    { "lng": 5.997218, "lat": 46.05107 },
    { "lng": 5.948493, "lat": 46.04266 },
    { "lng": 5.914794, "lat": 46.0523 },
    { "lng": 5.887331, "lat": 46.07407 },
    { "lng": 5.870269, "lat": 46.10469 },
    { "lng": 5.866195, "lat": 46.1395 },
    { "lng": 5.876784, "lat": 46.17488 },
    { "lng": 5.878724, "lat": 46.22663 },
    { "lng": 5.906689, "lat": 46.27411 },
    { "lng": 5.930834, "lat": 46.29367 },
    { "lng": 6.027417, "lat": 46.33407 },
    { "lng": 5.985898, "lat": 46.37143 },
    { "lng": 5.974156, "lat": 46.42372 },
    { "lng": 5.990442, "lat": 46.50188 },
    { "lng": 6.026311, "lat": 46.5455 },
    { "lng": 6.022255, "lat": 46.59403 },
    { "lng": 6.035602, "lat": 46.62634 },
    { "lng": 6.22881, "lat": 46.76464 },
    { "lng": 6.341668, "lat": 46.81127 },
    { "lng": 6.363179, "lat": 46.87154 },
    { "lng": 6.346201, "lat": 46.90367 },
    { "lng": 6.343411, "lat": 46.94033 },
    { "lng": 6.355511, "lat": 46.97504 },
    { "lng": 6.380481, "lat": 47.00202 },
    { "lng": 6.460064, "lat": 47.0564 },
    { "lng": 6.576143, "lat": 47.07433 },
    { "lng": 6.652275, "lat": 47.15662 },
    { "lng": 6.764373, "lat": 47.21768 },
    { "lng": 6.835864, "lat": 47.27423 },
    { "lng": 6.803207, "lat": 47.30456 },
    { "lng": 6.790738, "lat": 47.3367 },
    { "lng": 6.800235, "lat": 47.40676 },
    { "lng": 6.894733, "lat": 47.51086 },
    { "lng": 6.928989, "lat": 47.56657 },
    { "lng": 7.015293, "lat": 47.59424 },
    { "lng": 7.075224, "lat": 47.58216 },
    { "lng": 7.142397, "lat": 47.59277 },
    { "lng": 7.243866, "lat": 47.57342 },
    { "lng": 7.271519, "lat": 47.55022 },
    { "lng": 7.285798, "lat": 47.52329 },
    { "lng": 7.346517, "lat": 47.53069 },
    { "lng": 7.37208, "lat": 47.56329 },
    { "lng": 7.42208, "lat": 47.58618 },
    { "lng": 7.448489, "lat": 47.61448 },
    { "lng": 7.575359, "lat": 47.67885 },
    { "lng": 7.703819, "lat": 47.69021 },
    { "lng": 7.736406, "lat": 47.68004 },
    { "lng": 7.76446, "lat": 47.65614 },
    { "lng": 7.804089, "lat": 47.67608 },
    { "lng": 7.89273, "lat": 47.67742 },
    { "lng": 7.930025, "lat": 47.66899 },
    { "lng": 7.958027, "lat": 47.64814 },
    { "lng": 8.048813, "lat": 47.64786 },
    { "lng": 8.191781, "lat": 47.70993 },
    { "lng": 8.314922, "lat": 47.69564 },
    { "lng": 8.319516, "lat": 47.7273 },
    { "lng": 8.337261, "lat": 47.75773 },
    { "lng": 8.422989, "lat": 47.83705 },
    { "lng": 8.455337, "lat": 47.85624 },
    { "lng": 8.49701, "lat": 47.86304 },
    { "lng": 8.549818, "lat": 47.89661 },
    { "lng": 8.6846, "lat": 47.88607 },
    { "lng": 8.790438, "lat": 47.82635 },
    { "lng": 8.850936, "lat": 47.81664 },
    { "lng": 8.876567, "lat": 47.79465 },
    { "lng": 8.919398, "lat": 47.78106 },
    { "lng": 8.945503, "lat": 47.75688 },
    { "lng": 9.027525, "lat": 47.77646 },
    { "lng": 9.059951, "lat": 47.7698 },
    { "lng": 9.018813, "lat": 47.79878 },
    { "lng": 9.032583, "lat": 47.82917 },
    { "lng": 9.064145, "lat": 47.82828 },
    { "lng": 9.237082, "lat": 47.74286 },
    { "lng": 9.297137, "lat": 47.74129 },
    { "lng": 9.474565, "lat": 47.67988 },
    { "lng": 9.54697, "lat": 47.62715 },
    { "lng": 9.597715, "lat": 47.61384 },
    { "lng": 9.627587, "lat": 47.58008 },
    { "lng": 9.717273, "lat": 47.56334 },
    { "lng": 9.760949, "lat": 47.53126 },
    { "lng": 9.767215, "lat": 47.51395 },
    { "lng": 9.749904, "lat": 47.49278 },
    { "lng": 9.735549, "lat": 47.49286 },
    { "lng": 9.762804, "lat": 47.38884 },
    { "lng": 9.758399, "lat": 47.35224 },
    { "lng": 9.739689, "lat": 47.32047 },
    { "lng": 9.67065, "lat": 47.2814 },
    { "lng": 9.6013, "lat": 47.21222 },
    { "lng": 9.586933, "lat": 47.18624 },
    { "lng": 9.689447, "lat": 47.15178 },
    { "lng": 9.74309, "lat": 47.13179 },
    { "lng": 9.809019, "lat": 47.1252 },
    { "lng": 9.848298, "lat": 47.10726 },
    { "lng": 9.910891, "lat": 47.10429 },
    { "lng": 9.952157, "lat": 47.06957 },
    { "lng": 9.98115, "lat": 47.00257 },
    { "lng": 10.05529, "lat": 46.98344 },
    { "lng": 10.13323, "lat": 46.93819 },
    { "lng": 10.147, "lat": 46.94095 },
    { "lng": 10.16664, "lat": 46.98267 },
    { "lng": 10.19386, "lat": 47.00829 },
    { "lng": 10.25387, "lat": 47.02058 },
    { "lng": 10.30571, "lat": 47.06984 },
    { "lng": 10.39688, "lat": 47.08916 },
    { "lng": 10.54592, "lat": 47.00777 },
    { "lng": 10.56775, "lat": 46.98195 },
    { "lng": 10.57852, "lat": 46.9499 },
    { "lng": 10.5767, "lat": 46.91614 },
    { "lng": 10.55547, "lat": 46.86624 },
    { "lng": 10.5527, "lat": 46.80989 },
    { "lng": 10.51721, "lat": 46.70432 },
    { "lng": 10.56243, "lat": 46.67151 },
    { "lng": 10.58182, "lat": 46.62438 },
    { "lng": 10.55806, "lat": 46.51803 },
    { "lng": 10.53333, "lat": 46.47741 },
    { "lng": 10.48736, "lat": 46.44756 },
    { "lng": 10.43817, "lat": 46.44193 },
    { "lng": 10.39398, "lat": 46.46106 },
    { "lng": 10.27943, "lat": 46.46153 },
    { "lng": 10.25624, "lat": 46.41816 },
    { "lng": 10.24927, "lat": 46.36574 },
    { "lng": 10.2344, "lat": 46.33451 },
    { "lng": 10.25987, "lat": 46.29219 },
    { "lng": 10.26513, "lat": 46.2426 },
    { "lng": 10.23076, "lat": 46.18647 },
    { "lng": 10.15881, "lat": 46.13887 },
    { "lng": 10.04873, "lat": 46.12991 },
    { "lng": 9.978885, "lat": 46.16745 },
    { "lng": 9.958168, "lat": 46.20371 },
    { "lng": 9.924692, "lat": 46.22991 },
    { "lng": 9.895489, "lat": 46.28132 },
    { "lng": 9.786615, "lat": 46.24558 },
    { "lng": 9.759336, "lat": 46.21665 },
    { "lng": 9.728643, "lat": 46.2038 },
    { "lng": 9.617662, "lat": 46.19762 },
    { "lng": 9.513379, "lat": 46.21998 },
    { "lng": 9.444429, "lat": 46.28666 },
    { "lng": 9.388866, "lat": 46.32289 },
    { "lng": 9.379128, "lat": 46.28609 },
    { "lng": 9.338489, "lat": 46.23249 },
    { "lng": 9.320785, "lat": 46.18026 },
    { "lng": 9.276471, "lat": 46.14852 },
    { "lng": 9.234903, "lat": 46.09644 },
    { "lng": 9.176374, "lat": 46.06414 },
    { "lng": 9.147375, "lat": 46.00762 },
    { "lng": 9.119328, "lat": 45.98555 },
    { "lng": 9.15101, "lat": 45.96603 },
    { "lng": 9.170848, "lat": 45.93834 },
    { "lng": 9.178974, "lat": 45.90526 },
    { "lng": 9.167161, "lat": 45.85595 },
    { "lng": 9.129424, "lat": 45.81787 },
    { "lng": 9.089176, "lat": 45.75155 },
    { "lng": 9.023952, "lat": 45.72831 },
    { "lng": 8.95142, "lat": 45.74819 },
    { "lng": 8.902194, "lat": 45.74103 },
    { "lng": 8.853552, "lat": 45.76223 },
    { "lng": 8.82531, "lat": 45.80715 },
    { "lng": 8.830195, "lat": 45.86642 },
    { "lng": 8.80976, "lat": 45.89852 },
    { "lng": 8.766516, "lat": 45.90127 },
    { "lng": 8.721788, "lat": 45.92601 },
    { "lng": 8.70312, "lat": 45.96104 }
  ]
]
